import { render, staticRenderFns } from "./sales_table.vue?vue&type=template&id=318ce35c&scoped=true&"
import script from "./sales_table.vue?vue&type=script&lang=js&"
export * from "./sales_table.vue?vue&type=script&lang=js&"
import style0 from "./sales_table.vue?vue&type=style&index=0&id=318ce35c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318ce35c",
  null
  
)

export default component.exports